import { PolicyType } from '@/backend/market'

export const marketPolicyType = { ...PolicyType }
